<template>
  <div>
    <template v-if="survey">
      <topbar :showBack="true" :progressMax="survey.questions.length" :progressIndex="index" @back="onBack" />
      <div class="flex flex-col max-w-6xl w-full mx-auto">
        <div class="lg:flex justify-between lg:my-12 lg:px-2">
          <div class="lg:w-1/2 lg:mr-8">
            <card type="square">
              <img v-if="currentImage" :src="currentImage" alt="" class="w-full">
            </card>
          </div>
          <div class="lg:w-1/2 lg:ml-8 p-4 lg:p-0 lg:px-2">
            <component v-if="currentComponent" :is="currentComponent" :question="currentQuestion" :answer="currentAnswer" @input="answerQuestion($event)" :key="index" />
          </div>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import ProgressInfo from '@/components/ProgressInfo'
import MultipleChoiceQuestion from './MultipleChoiceQuestion'
import YesNoQuestion from './YesNoQuestion'
import { mapActions } from 'vuex'
import { surveysApi } from '@/services/api';

export default {
  props: {
    survey: Object,
  },
  data() {
    return {
      index: 0,
    }
  },
  computed: {
    currentComponent() {
      switch(this.currentQuestion.template) {
        case 'multiplechoice': return MultipleChoiceQuestion
        case 'yesno': return YesNoQuestion
      }
      return false;
    },

    currentImage() {
      if(this.currentQuestion.image) {
        return surveysApi.questionImage(this.survey.id, this.currentQuestion.image)
      } else {
        return false
      }
    },

    currentQuestion() {
      return this.survey.questions[this.index]
    },

    currentAnswer() {
      if(this.survey) {
        const localItem = localStorage.getItem(`lidate.survey.${this.survey.id}.${this.index}`)
        if(localItem) {
          return JSON.parse(localItem)
        }
      }
      return {};
    }
  },
  components: {
    ProgressInfo: ProgressInfo
  },
  methods: {
    ...mapActions('surveys', ['answerSurveyQuestion', 'persistSurveyAnswers']),
    onBack() {
      if(this.index > 0) {
        this.index = this.index - 1
      } else {
        this.$router.go(-1)
      }
    },
    answerQuestion(answer) {
      const answers = Array.isArray(this.answers) ? [...this.answers] : [];
      answers[this.index] = answer

      this.answerSurveyQuestion({
        id: this.survey.id,
        question: this.index,
        answer: answer
      })
      
      if(this.index + 1 < this.survey.questions.length) {
        this.index += 1
        
      } else {
        this.persistSurveyAnswers(this.survey)
        this.$emit('finished')
      }
    }
  }
}
</script>

<style>

</style>